import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Seo } from "../lib/seo";
import { PageHero } from "../components/PageHero";
import { Reveal, Stagger, StaggerItem } from "../components/motion";
import { INDUSTRIES } from "../data/industries";

export const Industries = () => (
  <>
    <Seo
      title="Industries We Serve"
      description="Legal services for startups, retail and e-commerce, manufacturing, food and beverage, real estate, professional services and SMEs across India."
      path="/industries"
    />
    <PageHero
      eyebrow="Industries We Serve"
      title={["Legal support, shaped", "around your industry."]}
      description="Different businesses carry different legal weight. A factory, a cloud kitchen and a consulting practice face different regulators, contracts and risks. Here is how the practice shows up for each."
    />

    <section className="bg-white py-24 sm:py-28">
      <div className="container-x space-y-6">
        {INDUSTRIES.map((ind, i) => (
          <Reveal key={ind.num} delay={i * 0.04}>
            <article
              className="group grid gap-8 border border-line p-9 transition-all duration-500 hover:border-gold/60 hover:shadow-[0_30px_70px_-40px_rgba(11,21,40,0.4)] sm:p-12 lg:grid-cols-12"
              data-testid={`industry-card-${ind.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="lg:col-span-5">
                <span className="font-mono text-xs text-gold-dark">{ind.num}</span>
                <h2 className="mt-4 font-serif text-3xl text-ink sm:text-4xl">{ind.name}</h2>
                <p className="mt-4 text-base leading-relaxed text-steel">{ind.tagline}</p>
              </div>
              <div className="lg:col-span-7">
                <p className="eyebrow">How we help</p>
                <Stagger className="mt-5 space-y-3.5" delay={0.1}>
                  {ind.helps.map((h) => (
                    <StaggerItem key={h}>
                      <p className="flex items-start gap-3 text-sm leading-relaxed text-steel">
                        <Check size={16} className="mt-0.5 shrink-0 text-gold-dark" />
                        {h}
                      </p>
                    </StaggerItem>
                  ))}
                </Stagger>
                <Link
                  to="/contact"
                  className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-navy transition-colors hover:text-gold-dark"
                >
                  Discuss your matter <ArrowRight size={15} />
                </Link>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  </>
);

export default Industries;
